module.exports = __webpack_public_path__ + "img/logo.e39310f2.png";